/**
 * A phone number with the Italian `+39` prefix, added unless the number already starts with it.
 *
 * @param {String} number - The phone number.
 *
 * @returns {String}
 */
export default function withItalianPrefix(number) {
  return number.startsWith('+39') ? number : `+39${number}`;
}
